import { validationMessages } from './validationMessages.schema';

export default {
  title: 'Profil',
  type: 'object',
  properties: {
    email: {
      title: 'Adres e-mail',
      type: 'string',
      format: 'email',
      fieldRequired: true
    },
    firstName: {
      title: 'Imię',
      type: 'string',
      fieldRequired: true
    },
    lastName: {
      title: 'Nazwisko',
      type: 'string',
      fieldRequired: true
    },
    gdprAccepted: {
      title:
        'Wyrażam zgodę na przetwarzanie moich danych osobowych dla potrzeb wykonania Usług (zgodnie z Ustawą z dnia 10 maja 2018 roku o Ochronie Danych Osobowych; Dz. U. z 2018, poz. 1000)',
      type: 'boolean',
      fieldRequired: true,
      validationMessages: {
        required: 'Błąd: Wyrażenie zgody jest wymagane.'
      }
    }
  },
  allOf: [validationMessages]
};
